















































import {Component, Vue} from 'vue-property-decorator'
import {NetworkModeHelper} from '@/helpers/NetworkModeHelper'

@Component
export default class NetworkModeAlert extends Vue {
  get isTestnet(): boolean {
    return NetworkModeHelper.isTestnet()
  }

  switchToMainnet() {
    NetworkModeHelper.switchTo('mainnet', this.$route?.name)
  }
}
